import { Assert } from "shared/assert";
import type { CoilStackPositionSelectModel } from "shared/coils/components/CoilStackPositionSelect.vue";
import { useCoilStore } from "shared/coils/stores/coilStore";
import type { StorageArea } from "shared/storageAreas/domain/storageArea";

export function useStorageAreaToCoilStack() {
  const coilStore = useCoilStore();

  function transform(storageArea: StorageArea): CoilStackPositionSelectModel {
    const coilStack = storageArea.coilStack;
    Assert.definied(coilStack);
    const coils = coilStore.getByStorageAreaId(storageArea.id);
    Assert.definied(coils);

    const model: CoilStackPositionSelectModel =  {
      id: storageArea.id,
      name: storageArea.name,
      slots: coilStack.slots,
      maxLevel: coilStack.maxLevels,
      maxHeight: coilStack.maxHeight,
      maxCoilDiameter: coilStack.maxCoilDiameter,
      slotsWidth: coilStack.slotWidth,
      coils: [],
      pixelPerMillimeter: 1/25
    };

    for (const coil of coils) {
      model.coils.push({
        id: coil.id,
        diameter: coil.diameter,
        level: coil.level,
        position: coil.position,
        name: coil.name
      });
    }

    return model;
  }

  return {
    transform
  };
}
